<template>
	<div class="g-signin-button" ref="signinBtn">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'g-signin-button',
		emits: ['success', 'error', 'failure'],
		props: {
			params: {
				type: Object,
				required: true,
				default() {
					return {}
				}
			}
		},
		mounted() {
			if (!window.gapi)
				throw new Error('"https://apis.google.com/js/api:client.js" needs to be included as a <script>.')

			if (!this.params.clientId && !this.params.client_id)
				throw new Error('Client Id must be specified.')

			window.gapi.load('auth2', () => {
				const auth2 = window.gapi.auth2.init(this.params)
				auth2.attachClickHandler(this.$refs.signinBtn, {}, googleUser => {
					this.$emit('success', googleUser)
				}, error => {
					this.$emit('error', error)
					this.$emit('failure', error) // an alias
				})
			})
		}
	}
</script>

<style></style>